import { gql } from "@apollo/client";

export const RESETEAR_SOLICITUD = gql`
    mutation ResetearSolicitud ($idSolicitud: Int!) {
        resetearSolicitud(idSolicitud: $idSolicitud)
    }
`;